import * as angular from 'angular';
import 'angular-bootstrap-toggle';
import { gameplanProductConfiguration, IGamePlanProductConfiguration } from './product-configuration';

import type * as ng from 'angular';

// Directives moved to directives folder.

// This interface was moved here as it is used in both workspace and reports common.
export interface IGamePlanRootScope extends ng.IRootScopeService {
    gpProductName: string;
    gpUseResourceCaption: boolean;
    gpResourceCaption: string;
    gpResourceCaption_lc: string;
    gpResourcesCaption: string;
    gpResourcesCaption_lc: string;
    productConfiguration: IGamePlanProductConfiguration;
}

export const gpCommon = angular.module("gamePlanCommon", [
    'ui.bootstrap',
    'ui.toggle',
]);


gpCommon.run([
    '$rootScope',
    function ($rootScope: IGamePlanRootScope) {

        Object.defineProperty($rootScope, "gpProductName", {
            get() { return gameplanProductConfiguration().productName },
            enumerable: true,
            configurable: true,
        });

        Object.defineProperty($rootScope, "productConfiguration", {
            get() { return gameplanProductConfiguration() },
            enumerable: true,
            configurable: true,
        });
    }
]);
